t = require('views/internal/teacup-with-helpers')('popover_trello_completer')

module.exports = t.renderable ->
  t.label ->
    t.format 'card-or-board-to-add'
    t.input '.js-search.js-autofocus', { type: 'text', placeholder: t.l('search-for-a-card-or-board-ellipsis') }

  t.div '.js-loading', ->
    t.span '.loading.spinner'

  t.div '.pop-over-section.js-card-results.hide', ->
    t.h4 '.pop-over-section-heading', ->
      t.format 'cards'

    t.ul '.pop-over-list.navigable.js-card-list'

    t.div '.empty.js-no-card-results.hide', { style: 'padding: 24px 6px' }, ->
      t.p '.u-bottom', ->
        t.format 'no-results'

  t.div '.pop-over-section.js-board-results.hide', ->
    t.h4 '.pop-over-section-heading', ->
      t.format 'boards'

    t.ul '.pop-over-list.navigable.js-board-list'

    t.div '.empty.js-no-board-results.hide', { style: 'padding: 24px 6px' }, ->
      t.p '.u-bottom', ->
        t.format 'no-results'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/popover_trello_completer.coffee